import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Symbols from './Symbols';

import styles from '../../../styles/animations/thumbs-feedback.module.scss';

import thumbUp from '../../../img/thumbup@2x.png';

const propTypes = {
    className: PropTypes.string,
    valid: PropTypes.bool,

    onAnimationComplete: PropTypes.func,
};

const defaultProps = {
    className: null,
    valid: null,
    onAnimationComplete: null,
};

function ThumbsFeedback({ className, valid, onAnimationComplete }) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.valid]: valid === true,
                    [styles.invalid]: valid === false,
                    [className]: className !== null,
                },
            ])}
        >
            <Symbols
                images={thumbUp}
                className={styles.symbols}
                animation={valid !== null ? 'rain-up' : null}
                onAnimationComplete={onAnimationComplete}
            />
        </div>
    );
}

ThumbsFeedback.propTypes = propTypes;
ThumbsFeedback.defaultProps = defaultProps;

export default ThumbsFeedback;
